var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 340,
    viewBox: "0 0 340 340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.458 170C251.458 164.132 246.701 159.375 240.833 159.375H106.25C100.382 159.375 95.6247 164.132 95.6247 170C95.6247 175.868 100.382 180.625 106.25 180.625H240.833C246.701 180.625 251.458 175.868 251.458 170Z",
    fill: "#4073F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.263 112.904C152.114 108.754 145.386 108.754 141.237 112.904L91.6537 162.487C87.5043 166.636 87.5043 173.364 91.6537 177.513L141.237 227.096C145.386 231.246 152.114 231.246 156.263 227.096C160.412 222.947 160.412 216.22 156.263 212.07L114.193 170L156.263 127.93C160.412 123.78 160.412 117.053 156.263 112.904Z",
    fill: "#4073F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left_arrow.d0d28dfef8f2cc4789941f8b75ebedbc.svg";
export { ForwardRef as ReactComponent };